import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hybse-admin-demo-issuers',
  templateUrl: './demo-issuers.component.html',
  styleUrls: ['./demo-issuers.component.css']
})
export class DemoIssuersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/components/pages/demo-company/demo-issuers/demo-issuers.component.ts